// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1ZqM3","additionalInfo":"AgreementModal_additionalInfo__NZH_p"};